module.exports = __webpack_public_path__ + "img/shogi_2021_pack_2_0007.4d216fb6.png";